import { render } from "./LibrariesIndex.vue?vue&type=template&id=acafe530"
import script from "./LibrariesIndex.vue?vue&type=script&lang=js"
export * from "./LibrariesIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__